import {
  aboutUs,
  backmarketWarranty,
  boMerchant,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  help,
  hireExternal,
  infosConsumer,
  legal,
  medium,
  modelsComparison,
  studentGoodDeals,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const atConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [aboutUs, hireExternal, studentGoodDeals],
      socials: [
        { name: 'instagram', href: 'https://www.instagram.com/backmarket_at' },
        {
          name: 'linkedin',
          href: 'https://www.linkedin.com/company/back-market',
        },
        { name: 'facebook', href: 'https://www.facebook.com/backmarket' },
        { name: 'x', href: 'https://x.com/back_market_de' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.at/de-at/seller/home',
        },
        boMerchant,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/de-at/articles/360026643854-Welche-Zahlungsarten-gibt-es-auf-Back-Market-',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/de-at/articles/360026646054-In-welches-Land-kann-ich-liefern-lassen-und-wie-viel-kostet-mich-das-',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/de-at/categories/360002106194-R%C3%BCckgabe-R%C3%BCckerstattung-Returns-Refunds--Devoluciones-y-reembolsos--%CE%95%CF%80%CE%B9%CF%83%CF%84%CF%81%CE%BF%CF%86%CE%AD%CF%82-%CE%91%CF%80%CE%BF%CE%B6%CE%B7%CE%BC%CE%B9%CF%8E%CF%83%CE%B5%CE%B9%CF%82-Reso-del-prodotto-e-rimborsi-Returns-Refunds--Retours-Remboursements-Retouren-en-terugbetalingen-Returns-refunds-',
        },
        help,
        buyingGuides,
        modelsComparison,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        backmarketWarranty,
        dataProtection,
        cookiePolicy,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/de-at/requests/new?ticket_form_id=12226993197084',
        },
        { translationKey: 'paymentMethods', href: '' },
      ],
    },
    {
      titleKey: 'categoryHello',
      links: [
        {
          translationKey: 'glassdoor',
          href: 'https://www.glassdoor.at/%C3%9Cberblick/Arbeit-bei-Back-Market-EI_IE1780208.11,22.htm?countryRedirect=true',
        },
        medium,
      ],
    },
    {
      logos: ['bcorp', 'customer-service-of-the-year'],
    },
  ],
}
